const customCyclingRaceConfig =
{
  7101: // Giro d'Italia 2025
  [
    {
      raceId: 1,
      raceName: 'DURAZZO\u2013 TIRANA',
      difficulty: 3,
      url: 'https://www.gazzetta.it/Giroditalia/storie/13-01-2025/giro-d-italia-2025-le-21-tappe-della-corsa-rosa-percorso-difficolta-altimetrie/tappa-1-nbsp-venerdi-9-maggio-durazzo-tirana-km-164-1800-metri-di-dislivello-3-stelle-di-difficolta.shtml',
    },
    {
      raceId: 2,
      raceName: 'TIRANA-TIRANA',
      difficulty: 3,
      url: 'https://www.gazzetta.it/Giroditalia/storie/13-01-2025/giro-d-italia-2025-le-21-tappe-della-corsa-rosa-percorso-difficolta-altimetrie/tappa-2-sabato-10-maggio-tirana-tirana-km-13-7-dislivello-150-metri-3-stelle.shtml',
    },
    {
      raceId: 3,
      raceName: 'VALONA-VALONA',
      difficulty: 3,
      url: 'https://www.gazzetta.it/Giroditalia/storie/13-01-2025/giro-d-italia-2025-le-21-tappe-della-corsa-rosa-percorso-difficolta-altimetrie/tappa-3-domenica-11-maggio-valona-valona-km-160-dislivello-2800-metri-3-stelle.shtml',
    },
    {
      raceId: 4,
      raceName: 'ALBEROBELLO-LECCE',
      difficulty: 1,
      url: 'https://www.gazzetta.it/Giroditalia/storie/13-01-2025/giro-d-italia-2025-le-21-tappe-della-corsa-rosa-percorso-difficolta-altimetrie/tappa-4-martedi-13-maggio-alberobello-lecce-km-187-dislivello-800-metri-1-stella.shtml',
    },
    {
      raceId: 5,
      raceName: 'CEGLIE MESSAPICA-MATERA',
      difficulty: 2,
      url: 'https://www.gazzetta.it/Giroditalia/storie/13-01-2025/giro-d-italia-2025-le-21-tappe-della-corsa-rosa-percorso-difficolta-altimetrie/tappa-5-mercoledi-14-maggio-ceglie-messapica-matera-km-144-dislivello-1550-metri-2-stelle.shtml',
    },
    {
      raceId: 6,
      raceName: 'POTENZA-NAPOLI',
      difficulty: 2,
      url: 'https://www.gazzetta.it/Giroditalia/storie/13-01-2025/giro-d-italia-2025-le-21-tappe-della-corsa-rosa-percorso-difficolta-altimetrie/tappa-6-giovedi-15-maggio-potenza-napoli-km-226-dislivello-2600-metri-2-stelle.shtml',
    },
    {
      raceId: 7,
      raceName: 'CASTEL DI SANGRO-TAGLIACOZZO',
      difficulty: 4,
      url: 'https://www.gazzetta.it/Giroditalia/storie/13-01-2025/giro-d-italia-2025-le-21-tappe-della-corsa-rosa-percorso-difficolta-altimetrie/tappa-7-venerdi-16-maggio-castel-di-sangro-tagliacozzo-km-168-dislivello-3500-metri-4-stelle.shtml',
    },
    {
      raceId: 8,
      raceName: 'GIULIANOVA-CASTELRAIMONDO',
      difficulty: 3,
      url: 'https://www.gazzetta.it/Giroditalia/storie/13-01-2025/giro-d-italia-2025-le-21-tappe-della-corsa-rosa-percorso-difficolta-altimetrie/tappa-8-sabato-17-maggio-giulianova-castelraimondo-km-197-dislivello-3800-metri-3-stelle.shtml',
    },
    {
      raceId: 9,
      raceName: 'GUBBIO-SIENA',
      difficulty: 2,
      url: 'https://www.gazzetta.it/Giroditalia/storie/13-01-2025/giro-d-italia-2025-le-21-tappe-della-corsa-rosa-percorso-difficolta-altimetrie/tappa-9-domenica-18-maggio-gubbio-siena-km-181-dislivello-2500-metri-2-stelle.shtml',
    },
    {
      raceId: 10,
      raceName: 'LUCCA-PISA',
      difficulty: 4,
      url: 'https://www.gazzetta.it/Giroditalia/storie/13-01-2025/giro-d-italia-2025-le-21-tappe-della-corsa-rosa-percorso-difficolta-altimetrie/tappa-10-martedi-20-maggio-lucca-pisa-km-28-6-dislivello-150-metri-4-stelle.shtml',
    },
    {
      raceId: 11,
      raceName: "VIAREGGIO-CASTELNOVO NE' MONTI",
      difficulty: 3,
      url: 'https://www.gazzetta.it/Giroditalia/storie/13-01-2025/giro-d-italia-2025-le-21-tappe-della-corsa-rosa-percorso-difficolta-altimetrie/tappa-11-mercoledi-21-maggio-viareggio-castelnovo-ne-monti-km-185-dislivello-3850-metri-3-stelle.shtml',
    },
    {
      raceId: 12,
      raceName: 'MODENA-VIADANA',
      difficulty: 2,
      url: 'https://www.gazzetta.it/Giroditalia/storie/13-01-2025/giro-d-italia-2025-le-21-tappe-della-corsa-rosa-percorso-difficolta-altimetrie/tappa-12-giovedi-22-maggio-modena-viadana-km-172-dislivello-1850-metri-2-stelle.shtml',
    },
    {
      raceId: 13,
      raceName: 'ROVIGO-VICENZA',
      difficulty: 2,
      url: 'https://www.gazzetta.it/Giroditalia/storie/13-01-2025/giro-d-italia-2025-le-21-tappe-della-corsa-rosa-percorso-difficolta-altimetrie/tappa-13-venerdi-23-maggio-rovigo-vicenza-km-180-dislivello-1600-metri-2-stelle.shtml',
    },
    {
      raceId: 14,
      raceName: 'TREVISO-NOVA GORICA/GORIZIA',
      difficulty: 2,
      url: 'https://www.gazzetta.it/Giroditalia/storie/13-01-2025/giro-d-italia-2025-le-21-tappe-della-corsa-rosa-percorso-difficolta-altimetrie/tappa-14-sabato-24-maggio-treviso-nova-gorica-gorizia-km-186-dislivello-1100-metri-2-stelle.shtml',
    },
    {
      raceId: 15,
      raceName: 'FIUME VENETO-ASIAGO',
      difficulty: 4,
      url: 'https://www.gazzetta.it/Giroditalia/storie/13-01-2025/giro-d-italia-2025-le-21-tappe-della-corsa-rosa-percorso-difficolta-altimetrie/tappa-15-domenica-25-maggio-fiume-veneto-asiago-km-214-dislivello-3900-metri-4-stelle.shtml',
    },
    {
      raceId: 16,
      raceName: 'PIAZZOLA SUL BRENTA-SAN VALENTINO',
      difficulty: 5,
      url: 'https://www.gazzetta.it/Giroditalia/storie/13-01-2025/giro-d-italia-2025-le-21-tappe-della-corsa-rosa-percorso-difficolta-altimetrie/tappa-16-martedi-27-maggio-piazzola-sul-brenta-san-valentino-km-199-dislivello-4900-metri-5-stelle.shtml',
    },
    {
      raceId: 17,
      raceName: "SAN MICHELE ALL'ADIGE-BORMIO",
      difficulty: 3,
      url: 'https://www.gazzetta.it/Giroditalia/storie/13-01-2025/giro-d-italia-2025-le-21-tappe-della-corsa-rosa-percorso-difficolta-altimetrie/tappa-17-mercoledi-28-maggio-san-michele-alladige-bormio-km-154-dislivello-3800-metri-3-stelle-nbsp.shtml',
    },
    {
      raceId: 18,
      raceName: 'MORBEGNO-CESANO MADERNO',
      difficulty: 2,
      url: 'https://www.gazzetta.it/Giroditalia/storie/13-01-2025/giro-d-italia-2025-le-21-tappe-della-corsa-rosa-percorso-difficolta-altimetrie/tappa-18-giovedi-29-maggio-morbegno-cesano-maderno-km-144-dislivello-1800-metri-2-stelle.shtml',
    },
    {
      raceId: 19,
      raceName: 'BIELLA-CHAMPOLUC',
      difficulty: 5,
      url: 'https://www.gazzetta.it/Giroditalia/storie/13-01-2025/giro-d-italia-2025-le-21-tappe-della-corsa-rosa-percorso-difficolta-altimetrie/tappa-19-venerdi-30-maggio-biella-champoluc-km-166-dislivello-4950-metri-5-stelle.shtml',
    },
    {
      raceId: 20,
      raceName: 'VERRES-SESTRIERE',
      difficulty: 5,
      url: 'https://www.gazzetta.it/Giroditalia/storie/13-01-2025/giro-d-italia-2025-le-21-tappe-della-corsa-rosa-percorso-difficolta-altimetrie/tappa-20-sabato-31-maggio-verres-sestriere-km-203-dislivello-4500-metri-5-stelle.shtml',
    },
    {
      raceId: 21,
      raceName: 'ROMA-ROMA',
      difficulty: 1,
      url: 'https://www.gazzetta.it/Giroditalia/storie/13-01-2025/giro-d-italia-2025-le-21-tappe-della-corsa-rosa-percorso-difficolta-altimetrie/tappa-21-domenica-1-giugno-roma-roma-km-141-dislivello-600-metri-1-stella-nbsp.shtml',
    },
  ],
};

export const extractData = (data, competitionId, raceId) => {
  const races = customCyclingRaceConfig[competitionId];
  if (!races) return undefined;
  const race = races.find(r => r.raceId.toString() === raceId.toString());
  return race[data];
};




// WEBPACK FOOTER //
// ./src/containers/CycleCalendar/utils/customCyclingConfig.js